import * as React from "react";
const SortingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path fill="#034A93" d="m12 12-4 4-4-4h8ZM4 4l4-4 4 4H4Z" />
  </svg>
);
export default SortingIcon;
